import React, { useEffect, useContext, useState } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { useForm } from "react-hook-form";
import { redirectToRealMe } from "../../Services/apiService";
import { AppContext } from "../../contexts/AppContext.jsx";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";
import ExternalLink from "../ExternalLink/ExternalLink.tsx";

const PendingVerification = ({ handleNext, handleBack }) => {
  const { appState } = useContext(AppContext);
  const [genderLabel, setGenderLabel] = useState("");
  const [addressCountryLabel, setAddressCountryLabel] = useState("");

  const passportData = appState.requestPayload.applicant;
  const applicationId = appState?.requestPayload?.applicationId || null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const options = { day: "numeric", month: "long", year: "numeric" };
      return new Date(dateStr).toLocaleDateString("en-NZ", options); // 27 April 1948
    } catch {
      return dateStr;
    }
  };

  useEffect(() => {
    // Load passport data from localStorage if not already in state

    console.log(passportData.genderId);
    getLabelFromId("GenderReference", passportData?.genderId).then(
      (genderLabel) => {
        setGenderLabel(genderLabel);
      }
    );
    console.log(passportData.countryOfBirthId);
    getCountryNameById(passportData.countryOfBirthId).then((countryName) => {
      setAddressCountryLabel(countryName);
    });
  }, [passportData?.genderId, passportData?.countryOfBirthId]);

  const { handleSubmit } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    handleNext();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          {/* <Progress progress={40} /> */}
          <h1 className="intro-title-mi" lang="mi-NZ">
            E tāria ana te hāponotanga
          </h1>
          <hr />
          <h1 className="intro-title">Pending verification</h1>

          <div className="step-container">
            <h2 className="step-title mb-2">
              Your application is being processed
            </h2>
            <p className="mb-4">
              We're processing your application. Check our website for current
              processing times.
            </p>
            <label className="terms-label">
              <ExternalLink
                href="https://www.realme.govt.nz/help/#how-long-does-it-take-to-get-a-realme-verified-identity/"
                text="RealMe — How long it takes to get a verified identity"
              />
            </label>
            <p className="mb-4">
              You'll receive an email confirming your application for a verified
              identity. We'll contact you if we need more information. When your
              verified identity is ready to use, we'll send an email to{" "}
              <strong>Adagnale@email.com</strong>.
            </p>
            <label className="terms-label">
              If you have any questions,{" "}
              <ExternalLink
                href="https://www.realme.govt.nz/contact-us/"
                text="contact us."
              />
            </label>

            <div className="step-button-container"></div>
            <h3 className="step-title mb-2">Your application details</h3>
            <div className="step-container-box">
              <p className="label">Application number</p>
              <p className="value">{applicationId}</p>
            </div>
            <div className="step-container-box">
              <p className="label">Full name</p>
              <p className="value">
                {passportData?.givenNames || ""}{" "}
                {passportData?.familyName || ""}
              </p>
            </div>
            <div className="step-container-box">
              <p className="label">Date of birth</p>
              <p className="value">{formatDate(passportData?.dateOfBirth)}</p>
            </div>
            <div className="step-container-box">
              <p className="label">Place of birth</p>
              <p className="value">
                {passportData?.placeOfBirth}, {addressCountryLabel}
              </p>
            </div>
            <div className="step-container-box">
              <p className="label">Gender</p>
              <p className="value">{genderLabel}</p>
            </div>
          </div>
          <div className="step-button-container">
            <SubmitButton
              text={"Back to RealMe"}
              type="submit"
              onClick={redirectToRealMe}
              Icon={BackIconWhite}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default PendingVerification;
